import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import COUNTIES from "../../shared/data/Counties";
import { Form, Col, Row, Container, Button } from "react-bootstrap";
import Select from "react-select";

const sortOptions = [
  { label: "All", value: "all" },
  { label: "ID Number", value: "epa_id" },
  { label: "Facility Name", value: "facility" },
  { label: "Owner", value: "owner" },
  { label: "Operator", value: "operator" },
];

const facilityStatus = [
  { label: "All", value: "both" },
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

const manifestType = [
  { label: "All", value: "" },
  { label: "Generator", value: "generator" },
  { label: "Transporter", value: "transporter" },
  { label: "TSDF", value: "tsdf" },
];

const epaType = [
  { label: "All", value: "all" },
  { label: "Permanent", value: "p" },
  { label: "Temporary", value: "t" },
];

const addressType = [
  { label: "All", value: "all" },
  { label: "Physical Address", value: "physical" },
  { label: "Mailing Address", value: "mailing" },
  { label: "Owner Address", value: "owner" },
  { label: "Operator Address", value: "operator" },
];

const epaCategory = [
  { label: "All", value: "all" },
  { label: "Federal", value: "federal" },
  { label: "State", value: "state" },
];

Object.byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

export default function SearchFields(props) {

  const renderKeywordInput = (
    name,
    type,
    className = "",
    placeholder = "",
    value = ""
  ) => {
    return (
      <input
        onChange={(e) => props.formik.setFieldValue(`filters.${name}`, e.target.value)}
        className={className}
        name={name}
        type={type}
        placeholder={placeholder}
        value={props.formik.values.filters.keyword}
        style={{ width: "100%" }}
      />
    );
  };

  const renderFilterInput = (name, placeholder, className = "test") => {
    return (
      <Form.Control
        name={name}
        placeholder={placeholder}
        value={props.formik.values.filters[name] !== "all" &&
          props.formik.values.filters[name] !== "both" &&
          props.formik.values.filters[name] !== ""
          ? props.formik.values.filters[name]
          : ""}
        onChange={(e) => props.formik.setFieldValue(`filters.${name}`, e.target.value)}
        as="input"
        onKeyPress={(e) => onEnterPress(e)}
        bsPrefix={"search-filter"}
        style={{
          width: "100%",
          minHeight: "38px",
          paddingLeft: "5px",
          lineHeight: "1.45"
        }}
      ></Form.Control>
    );
  };

  const renderFilterSelect = (name, placeholder, data, className = "") => {
    const customStyles = {
      menuPortal: (base) => ({
        ...base,
        zIndex: 999,
      }),
      menu: (base) => ({
        ...base,
        fontSize: "0.875rem",
        minWidth: "100%",
        width: "fit-content",
      }),
      dropdownIndicator: (base) => ({
        ...base,
        padding: 0,
      }),
      indicatorSeparator: (base) => ({}),
    };
    return (
      <div className="input-block" style={{ fontSize: "0.875rem" }}>
        <Select
          name={name}
          value={
            props.formik.values.filters[name] === "all" ||
              props.formik.values.filters[name] === "both" ||
              props.formik.values.filters[name] === ""
              ? ""
              :
              {
                value: Object.byString(props.formik.values.filters, name),
                label: data.find(
                  ({ value }) =>
                    value === Object.byString(props.formik.values.filters, name)
                )
                  ? data.find(
                    ({ value }) =>
                      value ===
                      Object.byString(props.formik.values.filters, name)
                  ).label
                  : Object.byString(props.formik.values.filters, name),
              }
          }
          options={data}
          isClearable={false}
          isMulti={false}
          placeholder={placeholder}
          onChange={(e) => props.formik.setFieldValue(`filters.${name}`, e.value)}
          styles={customStyles}
          menuPortalTarget={document.body}
        />
      </div>
    );
  };

  const renderFilterMultiSelect = (name, placeholder, data, className = "") => {
    const customStyles = {
      menuPortal: (base) => ({
        ...base,
        zIndex: 999,
      }),
      menu: (base) => ({
        ...base,
        fontSize: "0.875rem",
        minWidth: "100%",
        width: "fit-content",
      }),
      dropdownIndicator: (base) => ({
        ...base,
        padding: 0,
      }),
      indicatorSeparator: (base) => ({}),
    };
    return (
      <div style={{ fontSize: "0.875rem" }}>
        <Select
          name={name}
          value={props.formik.values.filters[name]}
          options={data}
          isMulti={true}
          placeholder={placeholder}
          onChange={(e) => props.formik.setFieldValue(`filters.${name}`, e)}
          styles={customStyles}
          menuPortalTarget={document.body}
        />
      </div>
    );
  };

  const renderFilterDate = (label, name) => {
    return (
      <Form.Control
        type="date"
        name={name}
        value={props.formik.values.filters[name]}
        onChange={(e) => props.formik.setFieldValue(`filters.${name}`, e.target.value, "")}
        style={{ color: "gray", fontSize: "0.875rem", minHeight: "38px" }}
      //isInvalid={!!props.errors[props.name]}
      />
    )
  }
  const onEnterPress = (e) => {
    if (e.charCode == 13) {
      props.formik.handleSubmit(e);
    }
  };

  return (
    <div className="section section-search collapsed">
      <Container>
        <Row className="mx-0 m-y">
          <Form onSubmit={props.formik.handleSubmit} style={{ display: "contents" }}>
            <Form.Control
              name="type"
              className="btn-block-xs"
              value={
                props.formik.values.filters.type !== "all" &&
                  props.formik.values.filters.type !== "both" &&
                  props.formik.values.filters.type !== ""
                  ? props.formik.values.filters.type
                  : ""
              }
              onChange={(e) => props.formik.setFieldValue(`filters.type`, e.target.value)}
              as="select"
              style={{
                width: "140px",
                backgroundColor: "#edf4f8",
                borderRadius: "30px 0px 0px 30px",
                height: "inherit"
              }}
              custom
            >
              <option value="" disabled>
                Search by...
                      </option>
              {sortOptions.map((d, i) => (
                <option key={d.value} value={d.value}>
                  {d.label}
                </option>
              ))}
            </Form.Control>
            <input
              onChange={(e) => props.formik.setFieldValue(`filters.keyword`, e.target.value)}
              className="search-textfield col-md-6 btn-block-xs"
              name="keyword"
              type="text"
              placeholder={`${props.formik.values.filters.type === "owner"
                ? "Enter a Owner Name"
                : props.formik.values.filters.type === "operator"
                  ? "Enter a Operator Name"
                  : props.formik.values.filters.type === "epa_id"
                    ? "Enter a ID Number"
                    : props.formik.values.filters.type === "facility"
                      ? "Enter a Facility Name"
                      : "Enter a Handler Name or ID Number"
                }`}
              value={props.formik.values.filters.keyword}
              style={{
                border: "none",
                marginTop: "1px",
                paddingRight: 0,
                // height: "36px",
                lineHeight: "32px",
              }}
            />
            {props.isFetching ? (
              <div
                className="cancel-button btn btn-block-xs"
                //style={{ height: "100%" }}
                onClick={() => props.cancelFetchFacilities()}
                title="Cancel Search"
              >
                <span className="ca-gov-icon-do-not-sign formearch">
                  <span className="sr-only">Cancel</span>
                </span>
              </div>
            ) : (
                <Button type="submit" className="search-button btn btn-standout btn-block-xs">
                  <span className="ca-gov-icon-search formearch">
                    <span className="sr-only">Search</span>
                  </span>
                </Button>
              )}
            <div className="ml-auto btn-block-xs">
              <a
                href="#handlerFilters"
                className="btn btn-secondary filter-toggle toggle-more btn-block-xs m-r-sm"
                role="tab"
                data-toggle="collapse"
                data-parent="#handlerFilters"
                aria-expanded="true"
                aria-controls="handlerFilters"
                aria-selected="false"
                id="ui-collapse-163"
                tabIndex="-1"
                style={{ height: "100%" }}
              >
                <span className="toggle-more" aria-expanded="false">
                  <span className="mr-1">Filters</span>
                  <span className="ca-gov-icon-filter" aria-hidden="true" />
                </span>
              </a>
              <div
                className="btn btn-secondary btn-block-xs m-r-sm"
                style={{ fontSize: "25px", padding: "0rem 0.75rem" }}
                onClick={props.onViewModeChange}
              >
                {props.viewMode === "card" ? (
                  <span
                    className="ca-gov-icon-table"
                    title="Switch to Grid View"
                  ></span>
                ) : (
                    <span
                      className="ca-gov-icon-page"
                      title="Switch to Card View"
                    ></span>
                  )}
              </div>
              <Link className="" to="/reports/advanced-handler-search">
                <div
                  className="btn btn-secondary btn-block-xs"
                >
                  <span>Advanced Search</span>
                </div>
              </Link>
            </div>
          </Form>
        </Row>
        <div
          className="collapse show handlerFilters filter-group"
          id="handlerFilters"
          role="tabpanel"
          aria-multiselectable="true"
          //tabIndex="-1"
          aria-labelledby="ui-collapse-163"
          aria-hidden="true"
          style={{ border: "none" }}
        >
          <Form onSubmit={props.formik.handleSubmit}>
            <div className="mb-2">
              <div className="search-filters m-l-0 m-r-0">
                <Row className="mx-0">
                  <div className="btn-block-xs" style={{ width: "145px" }}>
                    {renderFilterSelect(
                      "addressType",
                      "Address Type...",
                      addressType,
                      "search-filter-control"
                    )}
                  </div>
                  {props.formik.values.filters.type !== "epa_id" && (
                    <div className="btn-block-xs search-filter-control" style={{ width: "140px" }}>
                      {renderFilterInput("street", "Street...", "")}
                    </div>
                  )}
                  {props.formik.values.filters.type !== "epa_id" && (
                    <div className="btn-block-xs search-filter-control" style={{ width: "120px" }}>
                      {renderFilterInput(
                        "city",
                        "City...",
                        "search-filter-control"
                      )}
                    </div>
                  )}
                  {props.formik.values.filters.type !== "epa_id" && (
                    <div className="btn-block-xs search-filter-control" style={{ width: "95px" }}>
                      {renderFilterInput(
                        "zipCode",
                        "Zip Code...",
                        "search-filter-control"
                      )}
                    </div>
                  )}
                  {/* <div className="col-12 col-md-2 p-0 pl-1">
                        {this.renderFilterMultiSelect("city", "Cities...", this.state.cities, "search-filter-control")}
                      </div> */}
                  <div className="btn-block-xs" style={{ width: "195px" }}>
                    {renderFilterMultiSelect(
                      "multiCounty",
                      "County...",
                      COUNTIES,
                      "search-filter-control"
                    )}
                  </div>
                  <div className="btn-block-xs" style={{ width: "100px" }}>
                    {renderFilterSelect(
                      "manifestType",
                      "Handler...",
                      manifestType,
                      "search-filter-control"
                    )}
                  </div>
                  <div className="btn-block-xs" style={{ width: "90px" }}>
                    {renderFilterSelect(
                      "active",
                      "Status...",
                      facilityStatus,
                      "search-filter-control"
                    )}
                  </div>
                  <div className="btn-block-xs" style={{ width: "100px" }}>
                    {renderFilterSelect(
                      "epaIdCategory",
                      "Category...",
                      epaCategory,
                      "search-filter-control"
                    )}
                  </div>
                  <div className="btn-block-xs" style={{ width: "110px" }}>
                    {renderFilterSelect(
                      "epaIdType",
                      "ID Type...",
                      epaType,
                      "search-filter-control"
                    )}
                  </div>
                  <div className="ml-auto mt-2 mt-md-0 btn-block-xs">
                    <button
                      className="btn btn-primary m-r-sm search-filter-button"
                      onClick={props.handleOnSubmit}
                      style={{ height: "38px" }}
                    >
                      Update
                      </button>
                    <button
                      className="btn btn-standout search-filter-button"
                      type="button"
                      onClick={props.resetFilters}
                      style={{ height: "38px" }}
                    >
                      Clear
                      </button>
                  </div>
                </Row>
              </div>
            </div>
          </Form>
        </div>
      </Container>
    </div >
  );
}
